import { Box } from "@mui/material";

type TagProps = {
  hasGst?: boolean;
};

// Small GST / PAN badge shown at the end of billing entity dropdown options
export const BillingEntityTypeTag = ({ hasGst }: TagProps) => (
  <Box
    component="span"
    sx={{
      fontSize: "10px",
      fontWeight: 600,
      backgroundColor: hasGst ? "#c76a1f" : "#27c8d3",
      color: "#fff",
      borderRadius: "4px",
      px: "6px",
      py: "2px",
      minWidth: "20px",
      textAlign: "center",
      lineHeight: 1.4,
      flexShrink: 0,
    }}
  >
    {hasGst ? "GST" : "PAN"}
  </Box>
);

type OptionProps = {
  name: React.ReactNode;
  hasGst?: boolean;
};

// Billing entity name on the left, GST / PAN tag pushed to the right end
const BillingEntityOption = ({ name, hasGst }: OptionProps) => (
  <Box
    sx={{
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      gap: 1,
      flex: 1,
      width: "100%",
      minWidth: 0,
    }}
  >
    <Box sx={{ minWidth: 0, overflow: "hidden", textOverflow: "ellipsis" }}>
      {name}
    </Box>
    <BillingEntityTypeTag hasGst={hasGst} />
  </Box>
);

export default BillingEntityOption;
